import { ResultOf, VariablesOf } from 'gql.tada';

import { graphql } from '@flowtech/vendure-graphql-admin';

export const IMPORT_PRICING_RULES_MUTATION = graphql(`
  mutation ImportPricingRules($file: Upload!) {
    importPricingRules(file: $file) {
      totalProcessed
      succeeded
      failed
      errors {
        line
        message
      }
      warnings {
        line
        message
      }
    }
  }
`);
export type ImportPricingRulesMutation = typeof IMPORT_PRICING_RULES_MUTATION;
export type ImportPricingRulesResult = ResultOf<ImportPricingRulesMutation>;
export type ImportPricingRulesResultData =
  ImportPricingRulesResult['importPricingRules'];
export type ImportPricingRulesVars = VariablesOf<ImportPricingRulesMutation>;

export const EXPORT_MUTATION = graphql(`
  mutation ExportPricingRules {
    exportPricingRules {
      csvContent
    }
  }
`);
export type ExportPricingRulesMutation = typeof EXPORT_MUTATION;
export type ExportPricingRulesResult = ResultOf<ExportPricingRulesMutation>;
export type ExportPricingRulesResultData =
  ExportPricingRulesResult['exportPricingRules'];
